import React from "react";
import { cn } from "@/lib/utils";
import { SettlementBooking } from "@/components/pages/settlement/types/settlementBooking";

const asIsoString = (v: unknown): string => {
  if (typeof v === "string") return v;
  if (v instanceof Date) return v.toISOString();
  return String(v ?? "");
};

const formatDate = (value: unknown) => {
  const iso = asIsoString(value);
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

const StatusBadge = ({ value }: { value: string }) => (
  <span
    className={cn(
      "inline-flex items-center px-2 py-0.5 rounded-full",
      "text-xs border border-zinc-900",
    )}
  >
    {value}
  </span>
);

const shortId = (id: string) => (id?.length > 8 ? id.slice(0, 8) : id);

const GuestVisitRow = ({ v }: { v: SettlementBooking }) => {
  const dateLine = `${formatDate(v.arrivalDate)} → ${formatDate(v.departureDate)}`;

  const roomLine = `Room ${v?.room?.number ?? "—"} • ${v?.room?.category?.name ?? "—"}`;

  const bookingSource = (v as unknown as { bookingSource?: string })
    .bookingSource;

  return (
    <div className="w-full">
      <div className="flex items-start justify-between gap-6">
        <div className="flex flex-col gap-1">
          <div className="text-[12px] uppercase tracking-wide text-stone-500">
            Visit {shortId(v.id)}
            {bookingSource ? ` • ${bookingSource}` : ""}
          </div>

          <div className="text-base">
            <span className="font-medium">{dateLine}</span>
            <span className="text-stone-500"> • </span>
            <span className="text-stone-500">{roomLine}</span>
          </div>

          <div className="text-sm text-stone-500">
            Adults: {v.adults ?? "—"} • Children: {v.children ?? "—"} • Notes:{" "}
            {v.notesCount ?? 0}
          </div>
        </div>

        <StatusBadge value={v.status ?? "—"} />
      </div>

      <div className="mt-4 border-b border-zinc-900/60" />
    </div>
  );
};

export default GuestVisitRow;
